function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageQueue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(60.784314%,60.784314%,60.784314%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 14 1 L 37 1 C 38.102679 1 39 1.897321 39 3 L 39 24 C 39 25.102679 38.102679 26 37 26 L 14 26 C 12.897321 26 12 25.102679 12 24 L 12 3 C 12 1.897321 12.897321 1 14 1 Z M 14 1 ",
    transform: "matrix(0.875,0,0,0.875,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(60.784314%,60.784314%,60.784314%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 8 7 L 31 7 C 32.102679 7 33 7.897321 33 9 L 33 31 C 33 32.102679 32.102679 33 31 33 L 8 33 C 6.897321 33 6 32.102679 6 31 L 6 9 C 6 7.897321 6.897321 7 8 7 Z M 8 7 ",
    transform: "matrix(0.875,0,0,0.875,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(60.784314%,60.784314%,60.784314%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 3 13 L 25 13 C 26.102679 13 27 13.897321 27 15 L 27 37 C 27 38.102679 26.102679 39 25 39 L 3 39 C 1.897321 39 1 38.102679 1 37 L 1 15 C 1 13.897321 1.897321 13 3 13 Z M 3 13 ",
    transform: "matrix(0.875,0,0,0.875,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageQueue);
export default __webpack_public_path__ + "static/media/manageQueue.6826d6e2f74b6358dc109aa850a1a8c6.svg";
export { ForwardRef as ReactComponent };